/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaPaymentMethod model module.
 * @module model/AqaPaymentMethod
 * @version v0
 */
export default class AqaPaymentMethod {
  /**
   * Constructs a new <code>AqaPaymentMethod</code>.
   * @alias module:model/AqaPaymentMethod
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaPaymentMethod</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaPaymentMethod} obj Optional instance to populate.
   * @return {module:model/AqaPaymentMethod} The populated <code>AqaPaymentMethod</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaPaymentMethod();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('last4Digits'))
        obj.last4Digits = ApiClient.convertToType(data['last4Digits'], 'String');
      if (data.hasOwnProperty('expiryYear'))
        obj.expiryYear = ApiClient.convertToType(data['expiryYear'], 'String');
      if (data.hasOwnProperty('expiryMonth'))
        obj.expiryMonth = ApiClient.convertToType(data['expiryMonth'], 'String');
      if (data.hasOwnProperty('cardType'))
        obj.cardType = ApiClient.convertToType(data['cardType'], 'String');
      if (data.hasOwnProperty('default'))
        obj._default = ApiClient.convertToType(data['default'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaPaymentMethod.prototype.id = undefined;

/**
 * @member {String} last4Digits
 */
AqaPaymentMethod.prototype.last4Digits = undefined;

/**
 * @member {String} expiryYear
 */
AqaPaymentMethod.prototype.expiryYear = undefined;

/**
 * @member {String} expiryMonth
 */
AqaPaymentMethod.prototype.expiryMonth = undefined;

/**
 * @member {String} cardType
 */
AqaPaymentMethod.prototype.cardType = undefined;

/**
 * @member {Boolean} _default
 */
AqaPaymentMethod.prototype._default = undefined;

